import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles({
  pageWidth: {
    marginTop: '5%',
    width: '70%',
    marginBottom: 30
  }
})
